module.exports = __webpack_public_path__ + "img/auth.a13eb375.png";